export default __webpack_public_path__ + "static/media/pic5.b54058b1.jpg";